import { stringify } from 'query-string';
import { apiCreate, apiDelete, apiGetOne } from './ApiBaseActions';
export const API_GET_PROFFIT_SEARCH_GROUP = 'API_GET_PROFFIT_SEARCH_GROUP';
export const API_GET_PROFFIT_SEARCH_GROUP_SUCCESS = 'API_GET_PROFFIT_SEARCH_GROUP_SUCCESS';
export const API_CREATE_PROFFIT_SEARCH_GROUP = 'API_CREATE_PROFFIT_SEARCH_GROUP';
export const API_CREATE_PROFFIT_SEARCH_GROUP_ADMIN = 'API_CREATE_PROFFIT_SEARCH_GROUP_ADMIN';
export const API_GET_ONE_PROFFIT_SEARCH_GROUP_ADMIN_STATUS = 'API_GET_ONE_PROFFIT_SEARCH_GROUP_ADMIN_STATUS';
export const API_CREATE_PROFFIT_SEARCH_GROUP_BILLING_INFORMATION = 'API_CREATE_PROFFIT_SEARCH_GROUP_BILLING_INFORMATION';
export const API_GET_PROFFIT_SEARCH_GROUP_ACCOUNT_STATUS = 'API_GET_PROFFIT_SEARCH_GROUP_ACCOUNT_STATUS';
export const API_CREATE_PROFFIT_SEARCH_GROUP_ACCOUNT_LICENCE = 'API_CREATE_PROFFIT_SEARCH_GROUP_ACCOUNT_LICENCE';
export const API_CREATE_PROFFIT_SEARCH_GROUP_ACCOUNT_ASSIGN = 'API_CREATE_PROFFIT_SEARCH_GROUP_ACCOUNT_ASSIGN';
export const API_DELETE_PROFFIT_SEARCH_GROUP_ACCOUNT = 'API_DELETE_PROFFIT_SEARCH_GROUP_ACCOUNT';
export const API_UPDATE_PROFFIT_SEARCH_GROUP_ACCOUNT = 'API_UPDATE_PROFFIT_SEARCH_GROUP_ACCOUNT';
/**
 * アカウント管理の初期データ取得
 * @param meta
 * @returns {{payload: {}, meta: {cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetProffitSearchGroup = (meta) => apiGetOne(API_GET_PROFFIT_SEARCH_GROUP, '/proffit_search/group', meta || {});
/**
 * メンバー追加
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: {cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateProffitSearchGroup = (params, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_GROUP, '/proffit_search/group', params, meta || {});
/**
 * ご請求責任者の登録
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: {cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateProffitSearchGroupAdmin = (params, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_GROUP_ADMIN, '/proffit_search/group/admin', params, meta || {});
/**
 * ご請求責任者の登録可否のチェック
 * @param params
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetOneProffitSearchGroupAdminStatus = (params, meta) => apiGetOne(API_GET_ONE_PROFFIT_SEARCH_GROUP_ADMIN_STATUS, `/proffit_search/group/admin_status?${stringify(params)}`, params, meta || {});
/**
 * 請求書送付先（Cc）の登録
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: {cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateProffitSearchGroupBillingInformation = (params, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_GROUP_BILLING_INFORMATION, '/proffit_search/group/billing_information', params, meta || {});
/**
 * アカウントが追加可能か確認する
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: {cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetProffitSearchGroupAccountStatus = (params, meta) => apiGetOne(API_GET_PROFFIT_SEARCH_GROUP_ACCOUNT_STATUS, `/proffit_search/group/account_status?${stringify(params)}`, meta || {});
/**
 * 期間延長
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: {cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateProffitSearchGroupAccountLicence = (params, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_GROUP_ACCOUNT_LICENCE, '/proffit_search/group/account_licence', params, meta || {});
/**
 * 未入力枠への割り当て
 * @param id
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateProffitSearchGroupAccountAssign = (id, params, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_GROUP_ACCOUNT_ASSIGN, `/proffit_search/group/account/${id}/assign`, params, meta || {});
/**
 * アカウントの停止
 * @param id
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiDeleteProffitSearchGroupAccount = (id, meta) => apiDelete(API_DELETE_PROFFIT_SEARCH_GROUP_ACCOUNT, `/proffit_search/group/account/${id}`, meta || {});
/**
 * アカウントの更新
 * @param id
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiUpdateProffitSearchGroupAccount = (id, params, meta) => apiCreate(API_UPDATE_PROFFIT_SEARCH_GROUP_ACCOUNT, `/proffit_search/group/account/${id}/edit`, params, meta || {});
